module.exports = __webpack_public_path__ + "static/media/bleicon.7e11bb9b.webp";